import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="save-template-modal"
export default class extends Controller {
  static targets = ["nameInput", "error"];

  connect() {
    this.resolveCallback = null;
    this.originalForm = null;

    // Bind the outside click handler
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  // Show the modal and return a promise that resolves with the template name or null
  show(form) {
    this.originalForm = form;

    // Clear previous input and errors
    this.nameInputTarget.value = "";
    this.hideError();

    // Show the modal using the native dialog API
    if (this.element instanceof HTMLDialogElement) {
      this.element.showModal();
      this.element.addEventListener("click", this.handleOutsideClick);
      this.nameInputTarget.focus();
    }

    return new Promise((resolve) => {
      this.resolveCallback = resolve;
    });
  }

  // User wants to save the template
  saveTemplate() {
    const templateName = this.nameInputTarget.value.trim();

    if (!templateName) {
      this.showError();
      this.nameInputTarget.focus();
      return;
    }

    this.hide();
    if (this.resolveCallback) {
      this.resolveCallback(templateName);
    }
  }

  // User wants to skip saving the template
  skipTemplate() {
    this.hide();
    if (this.resolveCallback) {
      this.resolveCallback(null);
    }
  }

  // User cancelled (clicked outside or pressed Escape)
  cancel() {
    this.hide();
    if (this.resolveCallback) {
      this.resolveCallback(undefined); // undefined means "cancelled, don't submit form"
    }
  }

  // Handle clicks outside the dialog to close it
  handleOutsideClick(event) {
    // Ignore synthetic clicks (from keyboard events)
    if (event.clientX === 0 && event.clientY === 0) {
      return;
    }

    const rect = this.element.getBoundingClientRect();
    if (
      event.clientY < rect.top ||
      event.clientY > rect.bottom ||
      event.clientX < rect.left ||
      event.clientX > rect.right
    ) {
      this.cancel();
    }
  }

  // Handle Enter key to save, Escape handled by dialog natively
  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.saveTemplate();
    }
    // Escape is handled natively by the dialog element and calls cancel via the 'cancel' event
  }

  hide() {
    if (this.element instanceof HTMLDialogElement) {
      this.element.removeEventListener("click", this.handleOutsideClick);
      this.element.close();
    }
    this.hideError();
  }

  showError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.remove("hidden");
    }
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add("hidden");
    }
  }
}
